window.addEventListener('DOMContentLoaded', function () {
  const faq = document.querySelector('.faq-list');

  let myHash = window.location.hash;
  if (myHash) {
    myHash = myHash.substring(1);
    faq.querySelector('[data-bs-target]').dispatchEvent(new Event('click'));
    faq.querySelector('[data-bs-target="#collapse' + myHash + '"]').dispatchEvent(new Event('click'));
  }
});
